export default "__VITE_ASSET__DfDEIji$__"